import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview-section" }
const _hoisted_2 = { class: "overview-details-box" }
const _hoisted_3 = { class: "overview-value mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "overview-title mt-2" }, "Health needs", -1)
const _hoisted_5 = { class: "overview-details-box" }
const _hoisted_6 = { class: "overview-value mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "overview-title mt-2" }, "Health innovations", -1)
const _hoisted_8 = { class: "overview-details-box" }
const _hoisted_9 = { class: "overview-value mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "overview-title mt-2" }, "Innovators", -1)
const _hoisted_11 = { class: "overview-details-box" }
const _hoisted_12 = { class: "overview-value mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "overview-title mt-2" }, "Partners", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["overview-details", { 'bg-light': _ctx.background }])
      }, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.data.healthNeeds), 1)
      ], 2),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["overview-details", { 'bg-light': _ctx.background }])
      }, [
        _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.data.healthInnovations), 1)
      ], 2),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(["overview-details", { 'bg-light': _ctx.background }])
      }, [
        _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.data.innovators), 1)
      ], 2),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: _normalizeClass(["overview-details", { 'bg-light': _ctx.background }])
      }, [
        _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.data.partners), 1)
      ], 2),
      _hoisted_13
    ])
  ]))
}